module.exports = __webpack_public_path__ + "img/ticket-pattern-2-full.14bb4659.svg";